module.exports = __webpack_public_path__ + "img/3.dae8bf56.jpg";